export const SELLER_EMAIL_WEBFORM = {
  CLICK_SUBMIT: {
    pageName: 'ticket_email_webform_page',
    section: '',
    target: 'submit'
  },
  CLICK_TOPIC_LEVEL_1: {
    pageName: 'ticket_email_webform_page',
    section: 'topic',
    target: 'topic_level1'
  },
  CLICK_TOPIC_LEVEL_2: {
    pageName: 'ticket_email_webform_page',
    section: 'topic',
    target: 'topic_level2'
  },
  CLICK_ISSUE_NAME: {
    pageName: 'ticket_email_webform_page',
    section: 'issue',
    target: 'issue_name'
  },
  ACTION_TICKET_SUBMIT_RESULT: {
    pageName: 'ticket_email_webform_page',
    section: '',
    target: 'ticket_submit_result'
  },
  // account recover field
  CLICK_RECOVER: {
    pageName: 'ticket_email_webform_page',
    section: 'account_compromise_window',
    target: 'button'
  },
  IMPRESSION_RECOVER_WINDOW: {
    pageName: 'ticket_email_webform_page',
    section: 'account_compromise_window',
    target: 'button'
  },
  CLICK_CLOSE_RECOVER_WINDOW: {
    pageName: 'ticket_email_webform_page',
    section: 'account_compromise_window',
    target: 'close'
  },
  IMPRESSION_RECOVER_ALERT: {
    pageName: 'ticket_email_webform_page',
    section: 'account_compromise_copylink',
    target: ''
  },
  CLICK_RECOVER_ALERT: {
    pageName: 'ticket_email_webform_page',
    section: 'account_compromise_copylink',
    target: ''
  },
  CLICK_LOGIN_BANNER: {
    pageName: 'ticket_email_webform_page',
    section: 'banner',
    target: 'to_login_page'
  },
  // Secondary popup
  CLICK_CLOSE_RECOVER_ALERT: {
    pageName: 'ticket_email_webform_page',
    section: 'confirm_window',
    target: 'close'
  },
  CLICK_REGISTERED_ACCOUNT_LOGIN: {
    pageName: 'ticket_email_webform_page',
    section: 'email_account_registered',
    target: 'to_login_page'
  }
};
